<template>
  <!--
      作者：luoyiming
      时间：2020-06-04
      描述：插件中心-积分商城-商品设置-添加商品-商品信息
    -->
  <div>
    <el-form-item label="商品名称">
      <p class="fb">{{ form.product_name }}</p>
    </el-form-item>
    <el-form-item label="商品图片">
      <img :src="form.product_image" width="80" />
    </el-form-item>
    <el-form-item label="商品规格">
      <el-select v-model="form.spec_sku_id" @change="skuChanged" placeholder="请选择">
        <el-option v-if="getProductSkus.length == 1" key="-1" label="默认规格" :value="getProductSkus[0].value"></el-option>
        <el-option v-if="getProductSkus.length > 1" v-for="item in getProductSkus" :key="item.key" :label="item.label"
          :value="item.value">
        </el-option>
      </el-select>
      当前库存:{{ getProductSkus.length > 0 && stock_num == 0 ? getProductSkus[0].stock_num : stock_num }}
    </el-form-item>
  </div>
</template>
  
<script>
export default {
  data() {
    return {
      stock_num: 0,
      product_skus: []
    };
  },
  inject: ['form', 'product_sku'],
  computed: {
    getProductSkus() {
      return this.product_sku()
    }
  },
  created() {

  },
  methods: {
    skuChanged(e) {
      this.getProductSkus.forEach((item, index) => {
        if (item.value === e) {
          this.stock_num = item.stock_num
          return
        }
      })
    }
  }
};
</script>
  
<style></style>
  


// WEBPACK FOOTER //
// src/views/appsetting/cdk/product/info.vue